export { default } from './responsiveCalc'
